import { useTranslation } from 'react-i18next';

import ToggleChip from 'components/shared/ToggleChip/ToggleChip';
import { FlexBox } from './WeekDayPicker.styles';

import type { DayIndex } from '../../RecurrencePatternBuilder.types';
import type { WeekDayPickerProps } from './WeekDayPicker.types';

const WEEKDAY_INDEXES: DayIndex[] = [0, 1, 2, 3, 4, 5, 6];

const WeekDayPicker = ({ daysSelected, onChange }: WeekDayPickerProps) => {
  'use memo';
  const { t } = useTranslation('common', { keyPrefix: 'weekday' });

  const updateSelection = (idx: DayIndex) => {
    const newSelection = daysSelected.includes(idx)
      ? daysSelected.filter((x) => x !== idx)
      : [...daysSelected, idx];
    onChange(newSelection);
  };

  return (
    <FlexBox>
      {WEEKDAY_INDEXES.map((dayIndex) => {
        const isSelected = daysSelected.includes(dayIndex);
        return (
          <ToggleChip
            key={dayIndex}
            readonly={isSelected}
            disabled={!isSelected}
            label={t(dayIndex.toString())}
            value={isSelected}
            onClick={() => updateSelection(dayIndex)}
          />
        );
      })}
    </FlexBox>
  );
};

export default WeekDayPicker;
